import { Nullable } from '@clearverify/types';

import { AddressInfoFragment } from 'src/api';
import { DroppedFile } from 'src/types/file';

export enum CompanyInformationFormEmployerAdminFields {
  displayName = 'displayName',
  industry = 'industry',
  logoFile = 'logoFile',
  corporateStructure = 'corporateStructure',
  taxYearEndDate = 'taxYearEndDate',
  numberOfEmployees = 'numberOfEmployees',
  contactPhoneNumber = 'contactPhoneNumber',
  contactEmail = 'contactEmail',
  headquarters = 'headquarters',
  disclaimer = 'disclaimer',
}

export type CompanyInformationFormEmployerAdminValues = {
  [CompanyInformationFormEmployerAdminFields.displayName]: Nullable<string>;
  [CompanyInformationFormEmployerAdminFields.industry]: Nullable<string>;
  [CompanyInformationFormEmployerAdminFields.logoFile]: Nullable<DroppedFile>;
  [CompanyInformationFormEmployerAdminFields.contactEmail]: Nullable<string>;
  [CompanyInformationFormEmployerAdminFields.contactPhoneNumber]: Nullable<string>;
  [CompanyInformationFormEmployerAdminFields.taxYearEndDate]: Nullable<string>;
  [CompanyInformationFormEmployerAdminFields.corporateStructure]: Nullable<string>;
  [CompanyInformationFormEmployerAdminFields.numberOfEmployees]: Nullable<number>;
  [CompanyInformationFormEmployerAdminFields.disclaimer]: Nullable<string>;
  [CompanyInformationFormEmployerAdminFields.headquarters]: Nullable<
    Omit<AddressInfoFragment, 'id'>
  >;
};
